"use client"
import React, { createContext, useState } from "react";

interface IframeContextType {
  showIframe: boolean;
  isLoaded: boolean;
  scale: number;
  progress: number;
  showProgress: boolean;
  handleClick: () => void;
  handleIframeLoad: () => void;
  handleClose: () => void;
  isClosing: boolean;
}

export const IframeContext = createContext<IframeContextType | undefined>(undefined);

export const IframeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [showIframe, setShowIframe] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [scale, setScale] = useState(0.01);
  const [progress, setProgress] = useState(0);
  const [showProgress, setShowProgress] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  const handleClick = () => {
    setShowIframe(true);
    setShowProgress(true);
    setIsLoaded(false);
    setScale(0.01);
    setProgress(0);

    const progressInterval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 80) {
          clearInterval(progressInterval);
          return 80;
        }
        return prev + 5;
      });
    }, 100);
  };

  const handleIframeLoad = () => {
    setProgress(100);

    setTimeout(() => {
      setShowProgress(false);
      setIsLoaded(true);

      const scaleInterval = setInterval(() => {
        setScale((prev) => {
          if (prev >= 1) {
            clearInterval(scaleInterval);
            return 1;
          }
          return parseFloat((prev + 0.05).toFixed(2));
        });
      }, 20);
    }, 300);
  };

  const handleClose = () => {
    setIsClosing(true);

    const scaleInterval = setInterval(() => {
      setScale((prev) => {
        const next = parseFloat((prev - 0.05).toFixed(2));
        if (next <= 0.01) {
          clearInterval(scaleInterval);

          setTimeout(() => {
            setShowIframe(false);
            setIsLoaded(false);
            setIsClosing(false);
          }, 500);

          return 0.01;
        }
        return next;
      });
    }, 20);
  };

  return (
    <IframeContext.Provider
      value={{
        showIframe,
        isLoaded,
        scale,
        progress,
        showProgress,
        handleClick,
        handleIframeLoad,
        handleClose,
        isClosing,
      }}
    >
      {children}
    </IframeContext.Provider>
  );
};
